<template>
  <progressive-background v-if="images" :src="this.setRandomImage()" :blur="6" class="bg">
    <div class="home-content" slot="content" slot-scope="{ visible }">
      <div class="container">
        <h1>Outdoors | Photography | Sports </h1>
      </div>
    </div>
  </progressive-background>
</template>
<script>
import API from '../mixins/api';

export default {
  methods: {
    setRandomImage() {
      const num = this.images.length; 
      const rand = this.randomNumber(num);
      return this.images[rand].c[2].v;
    },
    randomNumber(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
  },
  mixins: [API],
};
</script>
<style lang="scss" scoped>
  .home-content {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: fixed;
    height: 100%;
    width: 100%;
    h1 {
      display: inline-block;
      background: rgba(63, 63, 63, 0.6);
      border-radius: 5px;
      padding: spacing(element);
      font-size: ms(0);
      @include respond-to(medium) {
        font-size: ms(1);
      }
    }
    @include respond-to(medium) {
      align-items: flex-start;
    }
    .container {
      text-align: right;
    }
  }
  .bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }
</style>
